export default __webpack_public_path__ + "static/media/hmc_mobile_app_download.0fa6527b.png";